<template>
  <div>
    <el-container>
      <!-- <el-aside
        width="200px"
        style="height: 800px;padding-right:10px;overflow: auto"
      >-->
      <!-- <el-row type="flex" justify="space-between" style="padding: 5px;align-items: center;">
          <el-col :span="18">
            <strong style="font-size: 1.5rem;">直播间管理</strong>
          </el-col>
          <el-col :span="6">
            <div style="text-align: right;color: #66b1ff;cursor: pointer;" @click="addDialog()">+直播间</div>
          </el-col>
      </el-row>-->
      <!-- <el-input
          style="width: 100%;"
          :size="componentSize"
          v-model="filter"
          placeholder="请输入参数"
          clearable
      ></el-input>-->
      <!-- <el-tree
          :data="treeData"
          :props="defaultProps"
          highlight-current
          :accordion="true"
          :expand-on-click-node="false"
          :filter-node-method="nodeFilter"
          @node-click="handleNodeClick"
          default-expand-all
          v-loading="treeLoading"
          ref="tree"
        >
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }"
            @mouseover="mouseover(data,$event)"
            @mouseleave="mouseleave(data,$event)"
          >
            <span style="width: 100%">{{ node.label }}</span>
            <span class="hide-tree-icon">
              <el-button type="text" size="mini" @click="() => addDialog(node, data)">
                <i class="el-icon-plus"></i>
              </el-button>
              <el-button type="text" size="mini" @click="() => updateDialog(node, data)">
                <i class="el-icon-edit"></i>
              </el-button>
              <el-button type="text" size="mini" @click="() => deleteTreeLiveRoom(data)">
                <i class="el-icon-close"></i>
              </el-button>
            </span>
          </span>
      </el-tree>-->

      <el-dialog
        title="添加"
        :visible.sync="treeAddFormVisible"
        :width="treeAddFormDialogWidth"
        left
        :close-on-click-modal="false"
      >
        <el-form
          ref="treeAddForm"
          :model="treeAddForm"
          :label-width="formLabelWidth"
          :rules="treeAddFormRules"
        >
          <el-row :gutter="20">
            <el-form-item label="直播名称" prop="name">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="treeAddForm.name"
                placeholder="请输入直播名称"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="date">
              <el-row>
                <el-col :span="12">
                  <el-date-picker
                    style="width: 100%;"
                    :size="componentSize"
                    v-model="treeAddForm.date"
                    value-format="yyyy-MM-dd"
                    align="right"
                    placeholder="选择日期时间"
                    clearable
                  ></el-date-picker>
                </el-col>
                <el-col :span="11">
                  <el-time-select
                    :size="componentSize"
                    style="width:100%"
                    placeholder="起始时间"
                    v-model="treeAddForm.beginTime"
                    :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '24:00'
                    }"
                  ></el-time-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="直播时长" prop="duration">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                type="number"
                v-model="treeAddForm.duration"
                placeholder="请输入直播时长"
                auto-complete="off"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click="treeAddFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="treeAddLiveRoom">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="编辑"
        :visible.sync="treeEditFormVisible"
        :width="treeEditFormDialogWidth"
        :close-on-click-modal="false"
        left
        v-if="permissions.indexOf('/liveRoom/updateLiveRoom') > -1"
      >
        <el-form
          class="tree-edit-form-dialog"
          ref="treeEditForm"
          :model="treeEditForm"
          :label-width="formLabelWidth"
          :rules="treeEditFormRules"
        >
          <el-row :gutter="20">
            <el-form-item label="直播名称" prop="name">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                v-model="treeEditForm.name"
                placeholder="请输入直播名称"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" prop="beginTime">
              <el-date-picker
                style="width: 100%;"
                :size="componentSize"
                v-model="treeEditForm.beginTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                placeholder="选择日期时间"
                :picker-options="pickerOptions"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="直播时长" prop="duration">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                type="number"
                v-model="treeEditForm.duration"
                placeholder="请输入直播时长"
                auto-complete="off"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="星期" prop="weekday">
              <el-input
                style="width: 100%;"
                :size="componentSize"
                type="number"
                v-model="treeEditForm.weekday"
                placeholder="请输入星期"
                auto-complete="off"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button @click="treeEditFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="treeUpdateLiveRoom">确 定</el-button>
        </div>
      </el-dialog>
      <!-- </el-aside> -->

      <el-main style="padding: 2px;">
        <!-- <el-card v-if="permissions.indexOf('/liveInfo/pageList') > -1"> -->

        <el-card>
          <div style="display:flex">
            <div class="liveInfo-left">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-input
                    style="width: 100%;"
                    :size="componentSize"
                    v-model="searchForm.name"
                    placeholder="请输入直播名称"
                    auto-complete="off"
                    clearable
                  ></el-input>
                </el-col>
                <el-col :span="6">
                  <el-select v-model="searchForm.liveState" clearable placeholder="请选择直播状态">
                    <el-option
                      v-for="(item,index) in liveStateList"
                      :key="index"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-date-picker
                    style="width:100%"
                    clearable
                    v-model="searchForm.period"
                    type="daterange"
                    range-separator="至"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                  ></el-date-picker>
                </el-col>
                <el-col :span="4" style="text-align:right">
                  <el-button
                    :size="componentSize"
                    type="primary"
                    @click="page.pageNumber=1,pageList"
                    icon="el-icon-search"
                  >搜索</el-button>
                  <!-- <el-button
                  :size="componentSize"
                  type="primary"
                  @click="reset"
                  icon="el-icon-refresh"
                  >重置</el-button>-->
                </el-col>
              </el-row>
              <el-row :span="24" style="margin-top:20px">
                <el-col :span="12">
                  <el-button
                    :size="componentSize"
                    type="primary"
                    @click="addFormVisible = true"
                    icon="el-icon-plus"
                  >添加</el-button>
                  <el-button :size="componentSize" @click="batchAddFormVisible = true">批量生成课次</el-button>
                  <!-- <el-button
                :size="componentSize"
                type="primary"
                @click="importFormVisible = true"
                icon="el-icon-download"
                  >导入</el-button>-->
                  <el-button
                    :size="componentSize"
                    type="danger"
                    @click="batchDeleteLiveInfo"
                    icon="el-icon-minus"
                    v-if="permissions.indexOf('/liveInfo/deleteLiveInfo') > -1"
                  >批量删除</el-button>
                </el-col>
                <el-col style="text-align: right" :span="12">
                  <el-button :size="componentSize" @click="importFormVisible = true">上传Excel</el-button>
                  <el-button :size="componentSize" @click="downloadFile()">下载模板</el-button>
                  <!-- <el-button
                :size="componentSize"
                type="primary"
                @click="importFormVisible = true"
                icon="el-icon-download"
                  >导入</el-button>-->
                  <!-- <el-button
                    :size="componentSize"
                    style="text-align: right"
                    type="primary"
                    @click="exportExcel"
                    :loading="loading"
                    icon="el-icon-upload2"
                    v-if="permissions.indexOf('/liveInfo/export') > -1"
                  >导出</el-button>-->
                </el-col>
              </el-row>
              <el-table
                :size="componentSize"
                ref="pageMultipleTable"
                node-key="id"
                :data="page.rows"
                tooltip-effect="dark"
                style="margin-top: 20px; width: 100%;"
                border
                highlight-current-row
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                @row-click="clickRow"
              >
                <el-table-column prop="name" label="直播名称"></el-table-column>
                <el-table-column prop="beginTime" label="开始时间"></el-table-column>
                <el-table-column prop="duration" label="直播状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.liveState=='1'">未开始</span>
                    <span v-if="scope.row.liveState=='2'">直播中</span>
                    <span v-if="scope.row.liveState=='3'">已结束</span>
                  </template>
                </el-table-column>
                <el-table-column prop="active" label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.active=='1'" @click="active(scope.row,-1)">上架</span>
                    <span v-if="scope.row.active=='-1'" @click="active(scope.row,1)">下架</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop label="启用/禁用" width="120">
              <template slot-scope="scope">
                <el-switch
                  class="switch-style"
                  :size="componentSize"
                  @change="active(scope.row)"
                  :active-value="1"
                  :inactive-value="-1"
                  active-text="启"
                  inactive-text="禁"
                  v-model="scope.row.active"
                  active-color="#409EFF"
                  inactive-color="#D2D2D2"
                ></el-switch>
              </template>
                </el-table-column>-->
                <el-table-column prop label="操作" width="150" align="center">
                  <template slot-scope="scope">
                    <div class="operationGroup">
                      <!-- <span
                    @click="selection = scope.row.id, editFormVisible = true"
                  >
                    <i class="el-icon-edit" title="编辑"></i>
                  </span>
                  <span
                    @click="deleteLiveInfo(scope.row)"
                  >
                    <i class="el-icon-delete" title="删除"></i>
                      </span>-->
                      <el-button
                        type="text"
                        @click="selection = scope.row.id, editFormVisible = true"
                      >编辑</el-button>
                      <el-button type="text" @click="goViewRecord(scope.row)">观看记录</el-button>
                      <el-dropdown>
                        <el-button type="text">更多</el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="getCourseList(scope.row)">查看视频</el-dropdown-item>
                          <el-dropdown-item @click.native="deleteLiveInfo(scope.row)">删除课次</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <!-- <div class="operationGroup">
                  <span
                    @click="selection = scope.row.id, detailFormVisible = true"
                    v-if="permissions.indexOf('/liveInfo/getLiveInfo') > -1"
                  >
                    <i class="el-icon-view" title="查看"></i>
                  </span>
                  <span
                    @click="selection = scope.row.id, editFormVisible = true"
                    v-if="permissions.indexOf('/liveInfo/updateLiveInfo') > -1"
                  >
                    <i class="el-icon-edit" title="编辑"></i>
                  </span>
                  <span
                    @click="deleteLiveInfo(scope.row)"
                    v-if="permissions.indexOf('/liveInfo/deleteLiveInfo') > -1"
                  >
                    <i class="el-icon-delete" title="删除"></i>
                  </span>
                    </div>-->
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                style="margin-top: 20px;text-align: right;"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </div>
            <div class="liveInfo-right">
              <div v-if="page.rows.length>0">
                <div class="liveInfo-flex">
                  <div class="liveInfo-title">{{liveName}}</div>
                  <div class="liveInfo-button" @click="openDataDialogVisible()">查看讲义</div>
                </div>
                <div class="liveInfo-time" style="margin-top:20px">开始时间：{{liveInfoDetail.startDate}}</div>
                <div class="liveInfo-time">结束时间：{{liveInfoDetail.invalidDate}}</div>
                <div class="liveInfo-time">老师口令：{{liveInfoDetail.teacherToken}}</div>
                <div class="liveInfo-time">助教口令：{{liveInfoDetail.assistantToken}}</div>
                <div class="liveInfo-time">
                  老师端URL：
                  <span
                    class="liveInfo-url"
                    @click="goUrl(liveInfoDetail.teacherJoinUrl)"
                  >{{liveInfoDetail.teacherJoinUrl}}</span>
                </div>
                <div class="liveInfo-image" v-if="linkTrue==true">
                  <!-- <img src="http://h.dppark.com/xwxtk/dl/images/%E6%8E%92%E8%AF%BE/u12699.png" /> -->
                  <div id="qrcode"></div>
                </div>
                <div class="liveInfo-time">
                  学生端URL：
                  <span
                    class="liveInfo-url"
                    @click="goUrl(liveInfoDetail.studentJoinUrl)"
                  >{{liveInfoDetail.studentJoinUrl}}</span>
                </div>
                <div class="liveInfo-image" v-if="linkTrue==true">
                  <!-- <img src="http://h.dppark.com/xwxtk/dl/images/%E6%8E%92%E8%AF%BE/u12699.png" /> -->
                  <div id="studentQrcode"></div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog
      title="添加直播"
      :visible.sync="addFormVisible"
      :width="addFormDialogWidth"
      left
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-form-item label="直播名称" prop="name">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              v-model="addForm.name"
              placeholder="请输入直播名称"
              auto-complete="off"
              maxlength="255"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="是否试看" prop="trial">
            <el-radio v-model="addForm.trial" label="1">是</el-radio>
            <el-radio v-model="addForm.trial" label="-1">否</el-radio>
          </el-form-item>
          <el-form-item label="开始时间" prop="date">
            <el-row>
              <el-col :span="12">
                <el-date-picker
                  style="width: 100%;"
                  :size="componentSize"
                  v-model="addForm.date"
                  value-format="yyyy-MM-dd"
                  align="right"
                  placeholder="选择日期时间"
                  clearable
                ></el-date-picker>
              </el-col>
              <el-col :span="11" style="margin-left:10px">
                <el-time-select
                  :size="componentSize"
                  style="width:100%"
                  placeholder="起始时间"
                  v-model="addForm.time"
                  :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '24:00'
                    }"
                ></el-time-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="直播时长" prop="duration">
            <!-- <el-input
              style="width: 100%;"
              :size="componentSize"
              type="number"
              v-model="addForm.duration"
              placeholder="请输入直播时长"
              auto-complete="off"
              maxlength="10"
              clearable
            >
              <template slot="append">min</template>
            </el-input>-->
            <el-select v-model="addForm.duration" placeholder="请选择直播时长" style="width:100%">
              <el-option value="30" label="0.5小时">0.5小时</el-option>
              <el-option value="60" label="1小时">1小时</el-option>
              <el-option value="90" label="1.5小时">1.5小时</el-option>
              <el-option value="120" label="2小时">2小时</el-option>
              <el-option value="150" label="2.5小时">2.5小时</el-option>
              <el-option value="180" label="3小时">3小时</el-option>
              <el-option value="210" label="3.5小时">3.5小时</el-option>
              <el-option value="240" label="4小时">4小时</el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addLiveInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量生成课次" :visible.sync="batchAddFormVisible" width="400px" left>
      <el-form
        ref="batchAddForm"
        :model="batchAddForm"
        :label-width="formLabelWidth"
        :rules="batchAddFormRules"
      >
        <el-row :gutter="20">
          <!-- <el-form-item label="直播名称" prop="type">
            <el-select v-model="batchAddForm.type" style="width:100%">
              <el-option value="按时间段批量生成">按时间段批量生成</el-option>
              <el-option value="Excel导入生成">Excel导入生成</el-option>
            </el-select>
          </el-form-item>-->
          <!-- <el-form-item label="上传文件" v-if="batchAddForm.type=='Excel导入生成'">
            <el-button @click="importFormVisible = true">上传Excel</el-button>
          </el-form-item>
          <el-form-item label="模版下载" v-if="batchAddForm.type=='Excel导入生成'">
            <el-button>下载模板</el-button>
          </el-form-item> -->
          <el-form-item label="设置日期" prop="period">
            <el-date-picker
              style="width:100%"
              v-model="batchAddForm.period"
              type="daterange"
              range-separator="至"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="开始时间" prop="time">
            <el-time-select
              :size="componentSize"
              style="width:100%"
              placeholder="开始时间"
              v-model="batchAddForm.time"
              :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '24:00'
                    }"
            ></el-time-select>
          </el-form-item>
          <el-form-item label="直播时长" prop="duration">
            <el-select v-model="batchAddForm.duration" placeholder="请选择直播时长" style="width:100%">
              <el-option value="30" label="0.5小时">0.5小时</el-option>
              <el-option value="60" label="1小时">1小时</el-option>
              <el-option value="90" label="1.5小时">1.5小时</el-option>
              <el-option value="120" label="2小时">2小时</el-option>
              <el-option value="150" label="2.5小时">2.5小时</el-option>
              <el-option value="180" label="3小时">3小时</el-option>
              <el-option value="210" label="3.5小时">3.5小时</el-option>
              <el-option value="240" label="4小时">4小时</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否试看" prop="trial">
            <el-radio v-model="batchAddForm.trial" label="1">是</el-radio>
            <el-radio v-model="batchAddForm.trial" label="-1">否</el-radio>
          </el-form-item>
          <el-form-item label="生成频率" prop="duration">
            <el-checkbox-group v-model="batchAddForm.weekdayList">
              <el-checkbox label="2">周一</el-checkbox>
              <el-checkbox label="3">周二</el-checkbox>
              <el-checkbox label="4">周三</el-checkbox>
              <el-checkbox label="5">周四</el-checkbox>
              <br />
              <el-checkbox label="6">周五</el-checkbox>
              <el-checkbox label="7">周六</el-checkbox>
              <el-checkbox label="1">周日</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="batchAddFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="batchAddLiveInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="detailFormVisible"
      :width="detailFormDialogWidth"
      left
      v-if="permissions.indexOf('/liveInfo/getLiveInfo') > -1"
    >
      <el-form
        class="detail-form-dialog"
        ref="detailForm"
        :model="detailForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="直播名称" prop="name">{{detailForm.name}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="beginTime">{{detailForm.beginTime}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="直播时长" prop="duration">{{detailForm.duration}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="星期" prop="weekday">{{detailForm.weekday}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      title="编辑直播"
      :visible.sync="editFormVisible"
      :width="editFormDialogWidth"
      left
      :close-on-click-modal="false"
    >
      <el-form
        class="edit-form-dialog"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <el-form-item label="直播名称" prop="name">
            <el-input
              style="width: 100%;"
              :size="componentSize"
              v-model="editForm.name"
              placeholder="请输入直播名称"
              auto-complete="off"
              maxlength="255"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="试看" prop="trial">
            <el-radio v-model="editForm.trial" label="1">是</el-radio>
            <el-radio v-model="editForm.trial" label="-1">否</el-radio>
          </el-form-item>
          <el-form-item label="开始时间" prop="date">
            <el-row>
              <el-col :span="12">
                <el-date-picker
                  style="width: 100%;"
                  :size="componentSize"
                  v-model="editForm.date"
                  value-format="yyyy-MM-dd"
                  align="right"
                  type="date"
                  placeholder="选择日期时间"
                  clearable
                ></el-date-picker>
              </el-col>
              <el-col :span="11" style="margin-left:10px">
                <el-time-select
                  :size="componentSize"
                  style="width:100%"
                  placeholder="起始时间"
                  v-model="editForm.time"
                  :picker-options="{
                      start: '06:00',
                      step: '00:15',
                      end: '24:00'
                    }"
                ></el-time-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="直播时长" prop="duration">
            <!-- <el-input
              style="width: 100%;"
              :size="componentSize"
              type="number"
              v-model="editForm.duration"
              placeholder="请输入直播时长"
              auto-complete="off"
              maxlength="10"
              clearable
            ></el-input>-->
            <!-- <el-select v-model="editForm.duration" placeholder="请选择直播时长">
              <el-option v-for="(item,index) in durationList" :value="item.value" :label="item.lable" :key="index"></el-option>
            </el-select>-->
            <el-select v-model="editForm.duration" placeholder="请选择直播时长" style="width:100%">
              <el-option value="30" label="0.5小时">0.5小时</el-option>
              <el-option value="60" label="1小时">1小时</el-option>
              <el-option value="90" label="1.5小时">1.5小时</el-option>
              <el-option value="120" label="2小时">2小时</el-option>
              <el-option value="150" label="2.5小时">2.5小时</el-option>
              <el-option value="180" label="3小时">3小时</el-option>
              <el-option value="210" label="3.5小时">3.5小时</el-option>
              <el-option value="240" label="4小时">4小时</el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateLiveInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="800px" left>
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="componentSize" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="直播名称"></el-table-column>
        <el-table-column prop="beginTime" label="开始时间"></el-table-column>
        <el-table-column prop="duration" label="直播时长"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="componentSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="上传讲义"
      :visible.sync="dataDialogVisible"
      :close-on-click-modal="false"
      width="60%"
    >
      <div style="margin-botton:20px;height:40px;">
        <el-upload
          style="float:left"
          class="upload-demo"
          :action="dataFileAction"
          :on-success="dataHandleSuccess"
          :file-list="fileList"
        >
          <el-button type="primary">点击上传</el-button>
        </el-upload>

        <span style="margin-left:20px;line-height:39.6px">常规文档格式，不能超10M</span>
        <!-- <el-button type="primary" style="float:right;" @click="addDefaultVideoMaterials">添加</el-button> -->
      </div>
      <el-table :data="tableData" border style="width: 100%;margin-top:20px;">
        <el-table-column prop="name" label="附件"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <i class="research-icon el-icon-download" @click="down(scope.row)"></i>
            <i class="research-icon el-icon-delete" @click="delect(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="预览视频"
      :visible.sync="videoDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
      width="80%"
    >
      <!-- <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>-->
      <div v-for="(item,index) in courseList" :key="index">
        <div class="liveInfo-showUrl" @click="openUrl(item.url)">全屏展示</div>
        <iframe
          width="100%"
          height="500px"
          :src="item.url"
          scrolling="yes"
          frameborder="no"
          border="0"
          marginwidth="0"
          marginheight="0"
          allowtransparency="yes"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import moment from "moment";
export default {
  components: { QRCode },
  data() {
    return {
      treeLoading: false,
      tableLoading: false,
      dataDialogVisible: false,
      blockTreeAddLiveRoom: false,
      blockTreeEditLiveRoom: false,
      blockTreeDeleteLiveRoom: false,
      blockAddLiveInfo: false,
      batchAddFormVisible: false,
      blockEditLiveInfo: false,
      blockDeleteLiveInfo: false,
      blockBatchDeleteLiveInfo: false,
      videoDialog: false,
      linkTrue: true,
      liveInfoDetail: {},
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      componentSize: "",
      addFormDialogWidth: "",
      detailFormDialogWidth: "",
      editFormDialogWidth: "",
      addFormVisible: false,
      detailFormVisible: false,
      batchAddFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      treeAddFormDialogWidth: "",
      treeEditFormDialogWidth: "",
      treeAddFormVisible: false,
      treeEditFormVisible: false,
      liveName: "",
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now();
        }
      },
      durationList: [],
      treeAddForm: {
        id: null,
        name: null,
        beginTime: null,
        duration: null,
        weekday: null
      },
      treeEditForm: {
        id: null,
        name: null,
        beginTime: null,
        duration: null,
        weekday: null
      },
      treeAddFormRules: {
        id: [
          {
            required: true,
            message: "请输入id",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "直播名称长度在0-255个字"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入直播时长",
            trigger: "blur"
          }
          //  {
          //   validator: this.validator.isInteger,
          //   message: '直播时长格式不正确',
          //   trigger: 'blur'
          // }
        ],
        weekday: [
          {
            required: true,
            message: "请输入星期",
            trigger: "blur"
          }
          // {
          //   validator: this.validator.isInteger,
          //   message: '星期格式不正确',
          //   trigger: 'blur'
          // }
        ]
      },
      treeEditFormRules: {
        id: [
          {
            required: true,
            message: "请输入id",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "直播名称长度在0-255个字"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入直播时长",
            trigger: "blur"
          }
          // {
          //   validator: this.validator.isInteger,
          //   message: '直播时长格式不正确',
          //   trigger: 'blur'
          // }
        ],
        weekday: [
          {
            required: true,
            message: "请输入星期",
            trigger: "blur"
          }
          // {
          //   validator: this.validator.isInteger,
          //   message: '星期格式不正确',
          //   trigger: 'blur'
          // }
        ]
      },
      searchForm: {
        name: null,
        liveState: null,
        period: null
      },
      liveStateList: [
        {
          id: 1,
          label: "未开始"
        },
        {
          id: 2,
          label: "直播中"
        },
        {
          id: 3,
          label: "已结束"
        }
      ],
      addForm: {
        id: null,
        name: null,
        date: null,
        time: null,
        trial: "-1",
        duration: null
      },
      batchAddForm: {
        id: null,
        name: null,
        time: null,
        trial: "-1",
        duration: null,
        weekdayList: [],
        period: []
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "直播名称长度在0-255个字"
          }
        ],
        trial: [
          {
            required: true,
            message: "请选择是否适用",
            trigger: "blur"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入直播时长",
            trigger: "blur"
          }
        ],
        date: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change"
          }
        ]
      },
      batchAddFormRules: {
        type: [
          {
            required: true,
            message: "请选择生成方式",
            trigger: "change"
          }
        ],
        trial: [
          {
            required: true,
            message: "请选择是否适用",
            trigger: "blur"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入直播时长",
            trigger: "blur"
          }
        ],
        period: [
          {
            required: true,
            message: "请选择设置时间",
            trigger: "change"
          }
        ],
        time: [
          {
            required: true,
            message: "请选择生成频率",
            trigger: "change"
          }
        ]
        // weekdayList: [
        //   {
        //     required: true,
        //     message: "请选择开始时间",
        //     trigger: "change"
        //   }
        // ],
      },
      detailForm: {
        id: null,
        name: null,
        beginTime: null,
        duration: null,
        weekday: null
      },
      editForm: {
        id: null,
        name: null,
        date: "",
        time: "",
        trial: "",
        duration: null
      },
      editFormRules: {
        id: [
          {
            required: true,
            message: "请输入id",
            trigger: "blur"
          }
        ],
        trial: [
          {
            required: true,
            message: "请选择是否适用",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入直播名称",
            trigger: "blur"
          },
          {
            min: 0,
            max: 255,
            message: "直播名称长度在0-255个字"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入直播时长",
            trigger: "blur"
          }
          // {
          //   validator: this.validator.isInteger,
          //   message: '直播时长格式不正确',
          //   trigger: 'blur'
          // }
        ],
        beginDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "blur"
          }
          // {
          //   validator: this.validator.isInteger,
          //   message: '星期格式不正确',
          //   trigger: 'blur'
          // }
        ]
      },
      importForm: {},
      searchFormLabelWidth: "0px",
      formLabelWidth: "80px",
      treeSelection: "",
      selection: "",
      multipleSelection: [],
      ids: [],
      courseList: [],
      rangePickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.POI_URL}/liveInfo/uploadExcel`,
      dataFileAction: `${process.env.POI_URL}/liveMaterials/upload`,
      liveInfoId: "",
      fileList: [],
      loading: false,
      permissions: [],
      filter: "",
      treeData: [],
      tableData: [],
      defaultProps: {
        children: "children",
        label: "name"
      }
    };
  },
  methods: {
    clickRow(row, event, column) {
      this.api.liveInfo
        .getZshdRoom({
          id: row.id
        })
        .then(result => {
          if (result.success) {
            this.liveInfoId = row.id;
            this.liveName = row.name;
            this.liveInfoDetail = result.data;
            this.$nextTick(function() {
              document.getElementById("qrcode").innerHTML = "";
              document.getElementById("studentQrcode").innerHTML = "";
              this.liveQrcode();
              this.studentLiveQrcode();
            });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clickRowReset(id) {
      this.api.liveInfo
        .getZshdRoom({
          id: id
        })
        .then(result => {
          if (result.success) {
            this.liveInfoDetail = result.data;
            this.liveInfoDetail.startDate = moment(
              this.liveInfoDetail.startDate
            ).format("YYYY-MM-DD  HH:mm:ss");
            this.liveInfoDetail.invalidDate = moment(
              this.liveInfoDetail.invalidDate
            ).format("YYYY-MM-DD  HH:mm:ss");
            this.$nextTick(function() {
              document.getElementById("qrcode").innerHTML = "";
              document.getElementById("studentQrcode").innerHTML = "";
              this.liveQrcode();
              this.studentLiveQrcode();
            });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    liveQrcode() {
      let that = this;
      let qrcode = new QRCode("qrcode", {
        width: 124,
        height: 124, // 高度
        text: that.liveInfoDetail.teacherJoinUrl // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },
    studentLiveQrcode() {
      let that = this;
      let qrcode = new QRCode("studentQrcode", {
        width: 124,
        height: 124, // 高度
        text: that.liveInfoDetail.studentJoinUrl // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    setComponentSize() {
      // this.componentSize = "medium";
      // if (document.body.clientWidth <= 992) {
      //   this.componentSize = "mini";
      //   return;
      // }
      // if (document.body.clientWidth <= 1200) {
      //   this.componentSize = "small";
      //   return;
      // }
      // if (document.body.clientWidth <= 1920) {
      //   this.componentSize = "medium";
      //   return;
      // }
    },
    setDialogWidth() {
      if (document.body.clientWidth > 1366) {
        this.addFormDialogWidth = "30%";
      } else {
        this.addFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = "40%";
      } else {
        this.detailFormDialogWidth = "50%";
      }
      if (document.body.clientWidth > 1366) {
        this.editFormDialogWidth = "30%";
      } else {
        this.editFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.treeAddFormDialogWidth = "30%";
      } else {
        this.treeAddFormDialogWidth = "40%";
      }
      if (document.body.clientWidth > 1366) {
        this.treeEditFormDialogWidth = "30%";
      } else {
        this.treeEditFormDialogWidth = "40%";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      // val.map(e => this.ids.push({ id: e.id }));
    },
    addDialog(node, data) {
      if (data === undefined) {
        this.treeAddForm.listParentId = "1";
      } else {
        this.treeAddForm.listParentId = "2";
      }
      this.treeAddFormVisible = true;
    },
    updateDialog(node, data) {
      this.treeEditForm.listParentId = "1";
      this.treeEditFormVisible = true;
      this.treeSelection = data.id;
    },
    treeGetLiveRoom() {
      this.api.liveRoom
        .getLiveRoom({
          id: this.treeSelection
        })
        .then(result => {
          if (result.success) {
            this.treeEditForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    treeAddLiveRoom() {
      if (this.blockTreeAddLiveRoom) {
        return false;
      }
      this.$refs.treeAddForm.validate(valid => {
        if (valid) {
          this.treeAddForm.id = this.$route.query.id;
          this.treeAddForm.beginTime =
            this.treeAddForm.beginTime + this.treeAddForm.beginTime1;
          this.blockTreeAddLiveRoom = true;
          this.api.liveRoom
            .addLiveRoom(this.treeAddForm)
            .then(result => {
              this.blockTreeAddLiveRoom = false;
              if (result.success) {
                this.treeAddFormVisible = false;
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockTreeAddLiveRoom = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    treeUpdateLiveRoom() {
      if (this.blockTreeEditLiveRoom) {
        return false;
      }
      this.$refs.treeEditForm.validate(valid => {
        if (valid) {
          this.blockTreeEditLiveRoom = true;
          this.api.liveRoom
            .updateLiveRoom(this.treeEditForm)
            .then(result => {
              this.blockTreeEditLiveRoom = false;
              if (result.success) {
                this.treeEditFormVisible = false;
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockTreeEditLiveRoom = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteTreeLiveRoom(data) {
      if (this.blockTreeDeleteLiveRoom) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockTreeDeleteLiveRoom = true;
          this.api.liveRoom
            .deleteLiveRoom([
              {
                id: data.id
              }
            ])
            .then(result => {
              this.blockTreeDeleteLiveRoom = false;
              if (result.success) {
                this.$message.success(result.message);
                this.getLiveRoomTree();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockTreeDeleteLiveRoom = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    getLiveInfoDetail() {
      this.api.liveInfo
        .getLiveInfoDetail({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.detailForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    tableRowClassName({ row, rowIndex }) {
      console.log("row", row);
      // if (rowIndex === 1) {
      //   return 'warning-row';
      // } else if (rowIndex === 3) {
      //   return 'success-row';
      // }
      // return '';
    },
    getDurationList() {
      let duration = 30;
      for (duration; ; duration = duration + 30) {
        if (duration > 240) {
          break;
        } else {
          let obj = {
            value: duration,
            label: duration / 60
          };
          this.durationList.push(obj);
        }
      }
    },
    getLiveInfo() {
      this.api.liveInfo
        .getLiveInfo({
          id: this.selection
        })
        .then(result => {
          if (result.success) {
            this.editForm = result.data;
            this.editForm.trial = String(this.editForm.trial);
            this.editForm.duration = String(this.editForm.duration);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.tableLoading = true;
      this.searchForm.liveRoomId = this.$route.query.id;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      if (
        this.searchForm.liveState != null &&
        this.searchForm.liveState != ""
      ) {
        this.searchForm.liveState = Number(this.searchForm.liveState);
      }
      this.api.liveInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.$nextTick(function() {
            this.$refs.pageMultipleTable.setCurrentRow(
              this.$refs.pageMultipleTable.data[0]
            );
          });
          if (this.page.rows.length > 0) {
            this.liveName = this.page.rows[0].name;
            this.liveInfoId = this.page.rows[0].id;
            this.clickRowReset(this.page.rows[0].id);
          }
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    goViewRecord(row) {
      localStorage.setItem("jump", JSON.stringify({ id: row.id }));
      this.$router.push({ path: "/viewRecord", query: { id: row.id } });
    },
    downloadFile() {
      const url = "./static/file/批量生成课次模板.xlsx";
      window.open(url);
    },
    goUrl(url) {
      window.open(url);
    },
    addLiveInfo() {
      if (this.blockAddLiveInfo) {
        return false;
      }
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addForm.liveRoomId = this.$route.query.id;
          this.addForm.beginTime = this.addForm.beginTime;
          this.blockAddLiveInfo = true;
          this.api.liveInfo
            .addLiveInfo(this.addForm)
            .then(result => {
              this.blockAddLiveInfo = false;
              if (result.success) {
                this.$message.success(result.message);
                this.addFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockAddLiveInfo = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    batchAddLiveInfo() {
      if (this.blockBatchAddLiveInfo) {
        return false;
      }
      this.$refs.batchAddForm.validate(valid => {
        if (valid) {
          // for(let item in this.batchAddForm.weekdayList){
          //   item = Number(item)
          //   console.log("item",item)
          // }
          this.batchAddForm.weekdayList = this.batchAddForm.weekdayList.map(
            Number
          );
          this.batchAddForm.beginTime = this.batchAddForm.beginTime;
          this.batchAddForm.liveRoomId = this.$route.query.id;
          this.blockBatchAddLiveInfo = true;
          this.api.liveInfo
            .batchAddLiveInfo(this.batchAddForm)
            .then(result => {
              this.blockBatchAddLiveInfo = false;
              if (result.success) {
                this.$message.success(result.message);
                this.batchAddFormVisible = false;
                this.pageList();
              } else {
                this.batchAddFormVisible = false;
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockBatchAddLiveInfo = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateLiveInfo() {
      if (this.blockEditLiveInfo) {
        return false;
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.blockEditLiveInfo = true;
          this.api.liveInfo
            .updateLiveInfo(this.editForm)
            .then(result => {
              this.blockEditLiveInfo = false;
              if (result.success) {
                this.$message.success(result.message);
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockEditLiveInfo = false;
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteLiveInfo(row) {
      if (this.blockDeleteLiveInfo) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockDeleteLiveInfo = true;
          this.api.liveInfo
            .deleteLiveInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              this.blockDeleteLiveInfo = false;
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              this.blockDeleteLiveInfo = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteLiveInfo() {
      if (this.blockBatchDeleteLiveInfo) {
        return false;
      }
      if (this.ids.length === 0) {
        this.$message.error("请选择要删除的数据！");
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.blockBatchDeleteLiveInfo = true;
          this.api.liveInfo
            .deleteLiveInfo(this.ids)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockBatchDeleteLiveInfo = false;
            })
            .catch(error => {
              this.blockBatchDeleteLiveInfo = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    dataHandleSuccess(response, file, fileList, $event) {
      console.log("response", response);
      console.log("file", file);
      let obj = {
        name: file.raw.name,
        size: file.raw.size,
        type: file.raw.type,
        url: response.data
        // objectId: this.appendexId,
      };
      let obj2 = {
        liveInfoId: this.liveInfoId,
        attachment: obj,
        type: 1
      };
      this.api.liveMaterials.addLiveMaterials(obj2).then(result => {
        if (result.success) {
          this.tableData.push(obj);
          // for (let i in this.tableData) {
          //   this.tableData[i].index = i;
          //   this.tableData[i].url = this.tableData[i].url.split("?")[0];
          // }
        }
      });
    },
    down(item) {
      const url = item.url;
      window.open(url);
    },
    delect(item) {
      console.log("item", item);
      this.$confirm("系统将删除该附件，是否确认删除？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          let obj = {
            id: item.id
          };
          this.api.attachment.deleteAttachment([obj]).then(result => {});
          this.tableData.splice(item.index, 1);
        })
        .catch(error => {
          console.log(error);
        });
    },
    openDataDialogVisible() {
      this.tableData = [];
      this.api.liveMaterials
        .getLiveMaterials({ liveInfoId: this.liveInfoId })
        .then(result => {
          if (result.success) {
            this.tableData = result.data.attachmentList;
          }
        });
      // this.appendexId = item.id;
      this.dataDialogVisible = true;
    },
    exportExcel() {
      this.loading = true;
      this.api.liveInfo
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      let obj = {
        liveRoomId: this.$route.query.id,
        liveInfoList: this.multipleSelection
      };
      this.api.liveInfo
        .importData(obj)
        .then(result => {
          if (result.success) {
            this.$message.success(result.message);
            this.importFormVisible = false;
            this.multipleSelection = [];
            this.pageList();
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLiveRoomTree() {
      this.treeLoading = true;
      this.api.liveRoom
        .getLiveRoomTree({})
        .then(result => {
          if (result.success) {
            this.treeData = result.data;
            if (this.treeData !== null && this.treeData.length > 0) {
              this.pageList();
            }
            this.treeLoading = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCourseList(row) {
      this.api.liveInfo
        .getCourseList({ id: row.id })
        .then(result => {
          if (result.success) {
            this.courseList = result.data;
            // this.playerOptions.sources[0].src = result.data.url;
            // window.open(result.data.url);
            if(this.courseList.length>0){
              this.videoDialog = true;
            }else{
              this.$message.error("暂无视频")
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    openUrl(url){
      this.videoDialog = false;
      window.open(url);
      this.courseList = [];
    },
    mouseover(data, $event) {
      $event.currentTarget.children[1].setAttribute("class", "show-tree-icon");
    },
    mouseleave(data, $event) {
      $event.currentTarget.children[1].setAttribute("class", "hide-tree-icon");
    },
    nodeFilter(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    treeFilter: function() {
      this.$refs.tree.filter(this.filter);
    },
    handleCommand(command) {
      if (command == "a") {
        this.playerOptions.sources[0].src = scope.row.url;
        this.videoDialog = true;
      }
      if (command != "a") {
        this.deleteLiveInfo(command);
      }
    },
    handleNodeClick(data) {
      if (!data.disabled) {
        this.pageList();
      }
    },
    active(row, active) {
      this.$confirm(
        "您确定要" + (active == -1 ? "下架" : "上架") + "此次直播吗？",
        "系统消息",
        {
          type: "warning"
        }
      ).then(() => {
        row.active = active;
        this.api.liveInfo
          .active(row)
          .then(result => {
            if (result.success) {
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
            this.pageList();
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          a.resources.forEach(x => this.permissions.push(x.url));
        });
      });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.addForm.time = "";
      } else {
      }
    },
    batchAddFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.batchAddForm.resetFields();
        this.batchAddForm.weekdayList = [];
      } else {
      }
    },
    detailFormVisible: function(newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".detail-form-dialog")
        });
        this.getLiveInfoDetail();
        loading.close();
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".edit-form-dialog")
        });
        this.getLiveInfo();
        loading.close();
      }
    },
    filter: function(newVal) {
      this.treeFilter();
    },
    treeAddFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.treeAddForm.resetFields();
        this.getLiveRoomTree();
      } else {
      }
    },
    treeEditFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.treeEditForm.resetFields();
        this.getLiveRoomTree();
      } else {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".tree-edit-form-dialog")
        });
        this.treeGetLiveRoom();
        loading.close();
      }
    }
  },
  mounted() {
    this.setComponentSize();
    this.setDialogWidth();
    this.getPermissionList();
    // this.getLiveRoomTree();
    this.pageList();
    this.getDurationList();
  }
};
</script>
<style scoped>
.liveInfo-left {
  width: 70%;
}
.liveInfo-right {
  border-left: 1px solid rgba(238, 238, 238, 1);
  width: 30%;
  margin-left: 30px;
  padding-left: 20px;
}
.liveInfo-flex {
  height: 16px;
}
.liveInfo-title {
  border-left: 2px solid rgba(77, 148, 255, 1);
  font-size: 16px;
  padding-left: 10px;
  line-height: 16px;
  float: left;
}
.liveInfo-button {
  float: right;
  color: #409eff;
  cursor: pointer;
}
.liveInfo-time {
  font-size: 13px;
  line-height: 33px;
}
.liveInfo-url {
  color: #409eff;
  cursor: pointer;
}
.liveInfo-image {
  height: 124px;
  width: 124px;
}
.custom-tree-node {
  width: 100%;
}

.hide-tree-icon {
  display: none;
}
.research-icon {
  margin: 0px 10px;
  font-size: 13px;
  color: #409eff;
}
.show-tree-icon {
  -webkit-animation-name: fadeInRight;
  -webkit-animation-duration: 0.5s;
  -webkit-animation-iteration-count: 1;
  display: inline-block;
  margin-left: 5px;
}

.liveInfo-showUrl{
  cursor: pointer;
  float: right;
  line-height: 30px;
  font-size: 14px;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
<style lang="less" rel="stylesheet/less">
// .el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
// .el-table__body tr.current-row > td {
//   background-color: rgb(250,250,250) !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/liveInfo/index.vue